export function formToSearchParams(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
        if (typeof value === "string" && value.trim() !== "")
            params.set(key, value);
    });
    return params;
}

export function applyRegionMunicipality(params, form) {
    const region_select = form.querySelector('[name="region"]');
    const municipalities_select = form.querySelector(
        '[name="municipality_code"]'
    );

    if (region_select) {
        const regions_arr = Array.from(region_select.options)
            .filter((o) => o.selected)
            .map((o) => o.value);
        if (regions_arr.length) params.set("region_code", regions_arr.join());
    }

    if (municipalities_select) {
        const municipalities_arr = Array.from(municipalities_select.options)
            .filter((o) => o.selected)
            .map((o) => o.value);
        if (municipalities_arr.length)
            params.set("municipality_code", municipalities_arr.join());
    }

    return params;
}
